import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import translations from './getAPIErrors.translations'
import { getBouyguesAddressAPIValidationErrors } from './getBouyguesAddressAPIValidationErrors'

// TODO fuse with getBouyguesAddressAPIValidationErrors which should just have the mapping exceptions
export const getAPIErrors = (error: Record<string, unknown>) => {
  const i18n = useI18n()

  return getBouyguesAddressAPIValidationErrors(error, i18n, {
    COUNTRY_DIAL_IN_CODE_PHONE_NUMBER_MISMATCH:
      translations.phoneNumberMismatch,
    POSTAL_CODE_INVALID: translations.postalCodeInvalid,
  })
}
